import { variables } from '../variables';
import AvenirNextBold from '../../fonts/HardAssetsAlliance/AvenirNext-Bold.woff2';
import AvenirNextDemiBold from '../../fonts/HardAssetsAlliance/AvenirNext-DemiBold.woff2';
import AvenirNextMedium from '../../fonts/HardAssetsAlliance/AvenirNext-Medium.woff2';
import AvenirNextRegular from '../../fonts/HardAssetsAlliance/AvenirNext-Regular.woff2';

export const hardAssetsAllianceColors = {
  // Primary colors
  colorPrimary: '#E2930A',
  colorPrimaryLight: '#eea527',
  colorPrimaryDark: '#d08400',
  colorProgressBarDefault: '#F4F4F4',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#FF5028',
  colorGrey: '#f4f4f4',

  // Button colors
  colorButtonPrimary: '#2B5769',
  colorButtonPrimaryInactive: '#A8BDC5',
  colorButtonPrimaryActive: '#234857',
  colorButtonSecoundary: '#F1F5F6', // don't use
  colorButtonSecondaryActive: '#E1E2E2F', // don't use
  colorButtonOutlined: '#ffffff',
  colorButtonOutlinedBorder: '#2B5769',
  colorButtonOutlinedText: '#2B5769',

  // Icon
  colorCheckedIcon: 'green',
  colorSuccess: '#00876A',

  // Text
  colorTextPrimary: '#4E7A8C', // blue
  colorTextSecondary: '#003246', // semiDark
  colorTextOutline: '#14213D', // blueOutline
  colorTextLight: '#807F83', // light
  colorTextXLLight: '#595959', // XL light
  colorTextGrey: '#8E8E8E', // grey
  colorTextGrey5: '#394A64', // grey 5
  colorTextGrey6: '#293854', // grey6
  colorTextError: '#FF0000', // red
  colorLink: '#003246', // semiDark

  // Backgrounds
  colorBackgroundPrimary: '#ffffff', // white
  colorBackgroundPrimaryDark: '#F7F7F7', // whitish
  colorBackgroundSecondary: '#fafafa', // xlGrey
  colorBackgroundSecondaryLight: '#F1F5F6', // light grey
  colorBackgroundSecondaryDark: '#16191D', // dark
  colorBackgroundSecondaryDark1: '#ECECEC', // dark1
  colorBackgroundDropzone: '#f9f9f9', // grey2
  colorBackgroundModal: 'rgba(0, 0, 0, 0.55)',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#C9D6DB', // grey
  colorBorderPrimaryDark: '#d8d8d8', // grey2
  colorBorderSecondary: '#EEA527', // yellow
  colorBorderSemiDark: 'rgba(78, 122, 140, 0.3)',
  colorsDivider: '#EDF2F3', // outline

  // svg colors
  colorSvgSemidark: '#2B5769',

  // Input
  colorInputBackground: '#2B5769',
  colorErrorMessage: '#FF5028',

  // Banner
  colorMisingInfoBackgorund: '#FFECB5',
  colorMissingInfoText: '#664D03',

  // Border
  colorBorder: '#5D90AD',

  // Footer Colors
  colorFooterBackground: '#172029',
  colorFooterText: '#6e8fae',

  // Loader
  colorLoader: '#2B5769',
};

export const hardAssetsAllianceFonts = `
  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextBold}) format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextDemiBold}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
    src: url(${AvenirNextRegular}) format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  *,
  *::after,
  *::before {
    font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
  }
`;
